import React from 'react';
import { glassStyle } from './themes';

/**
 * The real first hour, in the order the dashboard's setup checklist asks for
 * it. Kept deliberately concrete — "Build & publish · live instantly" told a
 * visitor nothing they could picture, and set an expectation DNS cannot meet.
 */
const STEPS = [
  {
    num: '01',
    title: 'Create the brand',
    desc: 'Name and domain — that is the whole form. Everything else is configured later from Settings.',
    meta: 'about a minute',
  },
  {
    num: '02',
    title: 'Connect your domain',
    desc: 'Add the record we show you at your registrar. Once it verifies, your site answers on your own address over HTTPS.',
    meta: 'minutes to a few hours, depending on DNS',
  },
  {
    num: '03',
    title: 'Publish a page',
    desc: 'Start from a template or build up from sections. Preview as a draft, publish when it reads right.',
    meta: 'same day',
  },
  {
    num: '04',
    title: 'Add products and take payment',
    desc: 'One product opens the storefront and checkout. Test with sandbox cards, then connect your Stripe to go live.',
    meta: 'whenever you are ready',
  },
];

export default function HowItWorks({ t }) {
  return (
    <div id='how' style={{ maxWidth: 1200, margin: '0 auto', padding: '80px 24px', position: 'relative', zIndex: 1 }}>
      <div style={{ textAlign: 'center', marginBottom: 56 }}>
        <h2 style={{ fontSize: 'clamp(28px, 4vw, 44px)', fontWeight: 800, color: t.text, letterSpacing: '-1px', margin: '0 0 14px' }}>
          Live on your own domain in four steps
        </h2>
        <p style={{ color: t.textSub, fontSize: 18, margin: 0 }}>
          The dashboard walks you through these in order, and remembers where you stopped.
        </p>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(min(240px, 100%), 1fr))', gap: 18 }}>
        {STEPS.map((s) => (
          <div key={s.num} style={{ ...glassStyle(t, { background: t.surface }), padding: 24, display: 'flex', flexDirection: 'column' }}>
            <div style={{ fontSize: 42, fontWeight: 800, background: 'linear-gradient(135deg, #7C3AED, #4F46E5)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', lineHeight: 1, marginBottom: 16 }}>{s.num}</div>
            <div style={{ color: t.text, fontWeight: 700, fontSize: 16, marginBottom: 8 }}>{s.title}</div>
            <p style={{ color: t.textSub, fontSize: 14, lineHeight: 1.7, margin: '0 0 14px', flex: 1 }}>{s.desc}</p>
            <div style={{ color: t.textMuted, fontSize: 12, borderTop: `1px solid ${t.border}`, paddingTop: 10 }}>{s.meta}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
